<template>
  <div>
    <!-- Loading -->
    <div v-if="loading" class="bg-white rounded-lg border border-growth-50 p-8 text-center text-growth-600">
      <svg class="animate-spin h-6 w-6 mx-auto mb-2" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/></svg>
      Loading ACO participation...
    </div>

    <!-- Card available -->
    <div v-else-if="card" class="bg-white rounded-lg border border-growth-50 overflow-hidden">
      <div class="px-4 py-3 border-b border-growth-50">
        <h3 class="text-sm font-semibold text-growth-900">ACO Participation</h3>
      </div>
      <div class="p-4">
        <div v-for="section in card.sections.filter(s => s.type === 'table')" :key="section.title">
          <table class="min-w-full text-sm">
            <thead>
              <tr class="text-left text-xs text-growth-600 uppercase border-b border-growth-50">
                <th v-for="col in section.columns" :key="col" class="pb-1 pr-3">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in section.rows" :key="i" class="border-b border-growth-50">
                <td v-for="(cell, j) in row" :key="j" class="py-1 pr-3">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Unavailable -->
    <div v-else-if="unavailableCard" class="bg-white rounded-lg border border-growth-50 p-6 text-center text-growth-600 text-sm">
      {{ unavailableCard.unavailable_reason || 'No ACO participation data available' }}
    </div>

    <!-- No insights yet -->
    <div v-else-if="!loading && insights" class="bg-white rounded-lg border border-growth-50 p-6 text-center text-growth-600 text-sm">
      No ACO participation data available
    </div>
  </div>
</template>

<script>
export default {
  name: 'PracticeAcoHistory',
  props: {
    insights: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  computed: {
    card() {
      if (!this.insights?.cards) return null
      return this.insights.cards.find(c => c.id === 'aco_participation' && c.available)
    },
    unavailableCard() {
      if (!this.insights?.cards) return null
      return this.insights.cards.find(c => c.id === 'aco_participation' && !c.available)
    },
  },
}
</script>
